import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { markTimeline } from 'console';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { DocumentService } from '../../services/document.service';
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';
import { UtilityService } from '../../services/utility.service';
@Component({
  selector: 'app-feedback-and-marking',
  templateUrl: './feedback-and-marking.component.html',
  styleUrls: ['./feedback-and-marking.component.scss']
})
export class FeedbackAndMarkingComponent implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  @Input('learnerId') currentLearner


  feedbackAndMarkingForm: any
  feedbackAndMarkingFormEdit: any
  learnerName: any
  jobData: any;
  learnerData: any
  assessorName: any
  loading = false
  assessorSign1: boolean
  learnerSign1: boolean
  IQASign1: boolean
  assessorSign2: boolean
  learnerSign2: boolean
  IQASign2: boolean
  isLearner: boolean = false
  isAdmin: boolean = false
  isTrainer: boolean = false
  isIQA: boolean = false;
  totalMarks = 0;

  constructor(
    public _learnerService: LearnerService,
    public _userRoleService: UserRoleService,
    public _documentService: DocumentService,
    public _utilityService: UtilityService,
  ) { }
  ngOnInit() {
    // this.createForm();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
      this.learnerName = this.learnerData.name
    }
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      this.getUserRole();
    }
    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.feedbackAndMarkingFormEdit = changes.assessmentEdit.currentValue
      let size = Object.keys(this.feedbackAndMarkingFormEdit).length;
      if (size != 0) {
        if (this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.assessorSign1 && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.assessorSign1 != "") {
          this.assessorSign1 = true
        }
        if (this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.learnerSign1 && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.learnerSign1 != "") {
          this.learnerSign1 = true
        }
        if (this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.iqaSign1 && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.iqaSign1 != "") {
          this.IQASign1 = true
        }
        if (this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.learnerSign2 && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.learnerSign2 != "") {
          this.learnerSign2 = true
        }
        if (this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.assessorSign2 && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.assessorSign2 != "") {
          this.assessorSign2 = true
        }
        if (this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.iqaSign2 && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.iqaSign2 != "") {
          this.IQASign2 = true
        }
        if (this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.total && this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.total != 0) {
          this.totalMarks = this.feedbackAndMarkingFormEdit.feedbackAndMarkingForm.total
        }
        this.createForm(this.feedbackAndMarkingFormEdit)
      }
    } else this.createForm()
  }


  // FOMR CONTROL

  createForm(details?) {
    this.feedbackAndMarkingForm = new FormGroup({
      learnerName: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.learnerName : this.learnerName),
      assessorName: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessorName : this.assessorName),
      assessmentRef1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessmentRef1 : ''),
      assessmentRef2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessmentRef2 : ''),
      assessmentRef3: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessmentRef3 : ''),
      assessmentRef4: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessmentRef4 : ''),
      assessorSign1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessorSign1 : ''),
      learnerSign1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.learnerSign1 : ''),
      iqaSign1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.iqaSign1 : ''),
      date1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.date1 : ''),
      date2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.date2 : ''),
      date3: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.date3 : ''),
      learnerName2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.learnerName2 : this.learnerName),
      assessorName2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessorName2 : this.assessorName),
      assessment1Mark1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment1Mark1 : ''),
      assessment1Mark2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment1Mark2 : ''),
      assessment1Mark3: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment1Mark3 : ''),
      assessment2Mark1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment2Mark1 : ''),
      assessment2Mark2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment2Mark2 : ''),
      assessment2Mark3: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment2Mark3 : ''),
      assessment3Mark1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment3Mark1 : ''),
      assessment3Mark2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment3Mark2 : ''),
      assessment3Mark3: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment3Mark3 : ''),
      assessment4Mark1: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment4Mark1 : ''),
      assessment4Mark2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment4Mark2 : ''),
      assessment4Mark3: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessment4Mark3 : ''),
      total: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.total : ''),
      grade: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.grade : ''),
      assessorSign2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.assessorSign2 : ''),
      learnerSign2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.learnerSign2 : ''),
      iqaSign2: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.iqaSign2 : ''),
      date4: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.date4 : ''),
      date5: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.date5 : ''),
      date6: new FormControl((details && details.feedbackAndMarkingForm) ? details.feedbackAndMarkingForm.date6 : ''),
    })
  }



  // UTILITY

  addSignature(formControl) {
    if (this.isLearner && ((formControl == 'assessorSign1') || (formControl == 'assessorSign2') || (formControl == 'iqaSign1') || (formControl == 'iqaSign2'))) {
      this.feedbackAndMarkingForm.get('assessorSign1').disable()
      this.feedbackAndMarkingForm.get('assessorSign2').disable()
      this.feedbackAndMarkingForm.get('iqaSign1').disable()
      this.feedbackAndMarkingForm.get('iqaSign2').disable()
    }
    else if (this.isTrainer && ((formControl == 'learnerSign1') || (formControl == 'learnerSign2') || (formControl == 'iqaSign1') || (formControl == 'iqaSign2'))) {
      this.feedbackAndMarkingForm.get('learnerSign1').disable()
      this.feedbackAndMarkingForm.get('learnerSign2').disable()
      this.feedbackAndMarkingForm.get('iqaSign1').disable()
      this.feedbackAndMarkingForm.get('iqaSign2').disable()
    }
    else if (this.isIQA && ((formControl == 'learnerSign1') || (formControl == 'learnerSign2') || (formControl == 'assessorSign1') || (formControl == 'assessorSign2'))) {
      this.feedbackAndMarkingForm.get('learnerSign1').disable()
      this.feedbackAndMarkingForm.get('learnerSign2').disable()
      this.feedbackAndMarkingForm.get('assessorSign1').disable()
      this.feedbackAndMarkingForm.get('assessorSign2').disable()
    } else {
      this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
        null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
          if (data == undefined) return
          console.log("Sign in form", data, formControl);

          let sign = data
          if (formControl == 'assessorSign1') {
            this.assessorSign1 = true
            this.feedbackAndMarkingForm.patchValue({
              assessorSign1: sign
            })
          }
          if (formControl == 'assessorSign2') {
            this.assessorSign2 = true
            this.feedbackAndMarkingForm.patchValue({
              assessorSign2: sign
            })
          }
          if (formControl == 'learnerSign1') {
            this.learnerSign1 = true
            this.feedbackAndMarkingForm.patchValue({
              learnerSign1: sign
            })
          }
          if (formControl == 'learnerSign2') {
            this.learnerSign2 = true
            this.feedbackAndMarkingForm.patchValue({
              learnerSign2: sign
            })
          }
          if (formControl == 'iqaSign1') {
            this.IQASign1 = true
            this.feedbackAndMarkingForm.patchValue({
              iqaSign1: sign
            })
          }
          if (formControl == 'iqaSign2') {
            this.IQASign2 = true
            this.feedbackAndMarkingForm.patchValue({
              iqaSign2: sign
            })
          }
        })
      console.log("feed back form value", this.feedbackAndMarkingForm.value);

    }
  }

  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true
  }


  onChangeEvent(value, formGroup, formControl) {
    if (formGroup == 'feedbackAndMarkingForm') this.feedbackAndMarkingForm.get(formControl).setValue(value);
  }

  calculateMarks(event, formControl, mark) {
    console.log("Event", event, formControl, typeof mark, mark);

    if (event && event.checked) this.totalMarks = this.totalMarks + mark
    else this.totalMarks -= mark
    this.feedbackAndMarkingForm.get(formControl).setValue(event.checked);
    this.feedbackAndMarkingForm.get('total').setValue(this.totalMarks);
    if (this.totalMarks <= 6 && this.totalMarks >= 4) this.feedbackAndMarkingForm.get('grade').setValue('Pass');
    if (this.totalMarks <= 8 && this.totalMarks >= 7) this.feedbackAndMarkingForm.get('grade').setValue('Merit');
    if (this.totalMarks <= 12 && this.totalMarks >= 9) this.feedbackAndMarkingForm.get('grade').setValue('Distinction');
    if (this.totalMarks < 4) this.feedbackAndMarkingForm.get('grade').setValue('');
    console.log("This is the final total marks", this.totalMarks);
  }


  // API CALL


  feedbackAndMarkingFormSubmit() {
    console.log("Value of check list form", this.feedbackAndMarkingForm.value);

    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        feedbackAndMarkingForm: this.feedbackAndMarkingForm.value,
      },
      // type: 'markingScheme'
    }
    this.loading = true
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      // this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this._utilityService.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" })
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("Marking Schema not accepted", err)
    })

  }


}
